export const DocumentAnalysisModelEnum = {
  iban: 'iban',
  proof_of_address: 'proof_of_address',
  registration_certificate: 'registration_certificate',
  prompt: 'prompt',
} as const;
export type DocumentAnalysisModelEnum =
  (typeof DocumentAnalysisModelEnum)[keyof typeof DocumentAnalysisModelEnum];
